import { JobTitle } from './job-title.model';

export class JobTitleWithTargetDifference {
    jobTitle: JobTitle;
    targetDifference: number;
}
